module.exports = {
	"id": "VE",
	"name": "Venezuela",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": 0.083578,
			"7": null,
			"8": 0.007598,
			"9": null,
			"10": null,
			"11": 0.03799,
			"12": 0.015196,
			"13": 0.022794,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.022794,
			"19": null,
			"20": 0.053186,
			"21": 0.022794,
			"22": 0.015196,
			"23": 0.007598,
			"24": 0.03799,
			"25": 0.022794,
			"26": 0.022794,
			"27": 0.03799,
			"28": 0.007598,
			"29": 0.022794,
			"30": 0.030392,
			"31": 0.030392,
			"32": 0.022794,
			"33": 0.022794,
			"34": 0.030392,
			"35": 0.03799,
			"36": 0.053186,
			"37": 0.083578,
			"38": 0.060784,
			"39": 0.068382,
			"40": 0.053186,
			"41": 0.121568,
			"42": 0.045588,
			"43": 0.212744,
			"44": 0.11397,
			"45": 0.106372,
			"46": 0.22794,
			"47": 0.18995,
			"48": 0.167156,
			"49": 6.207566,
			"50": 0.250734,
			"51": 1.276464,
			"52": 0.926956,
			"53": 33.104486,
			"54": 9.847008,
			"55": 0.11397,
			"56": 0.015196,
			"57": null
		},
		"firefox": {
			"2": 0.07598,
			"3": 0.053186,
			"4": 0.007598,
			"5": null,
			"6": 0.007598,
			"7": null,
			"8": 0.782594,
			"9": null,
			"10": null,
			"11": 0.007598,
			"12": 0.022794,
			"13": 0.015196,
			"14": 0.015196,
			"15": null,
			"16": 0.015196,
			"17": 0.007598,
			"18": null,
			"19": 0.007598,
			"20": 0.015196,
			"21": 0.007598,
			"22": 0.007598,
			"23": 0.07598,
			"24": 0.015196,
			"25": 0.015196,
			"26": 0.091176,
			"27": 0.676222,
			"28": 0.015196,
			"29": 0.03799,
			"30": 0.030392,
			"31": 0.03799,
			"32": 0.015196,
			"33": 0.030392,
			"34": 0.03799,
			"35": 0.045588,
			"36": 0.030392,
			"37": 0.045588,
			"38": 0.091176,
			"39": 0.07598,
			"40": 0.098774,
			"41": 0.053186,
			"42": 0.060784,
			"43": 0.319116,
			"44": 0.07598,
			"45": 0.273528,
			"46": 0.121568,
			"47": 0.812986,
			"48": 0.64583,
			"49": 7.605598,
			"50": 0.083578,
			"51": 0.015196,
			"52": null,
			"3.5": 0.015196,
			"3.6": 0.30392
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.015196,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.015196,
			"34": null,
			"35": null,
			"36": 0.068382,
			"37": 0.060784,
			"38": 0.098774,
			"39": 0.022794,
			"40": 0.478674,
			"41": 0.083578,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.015196
		},
		"safari": {
			"0": null,
			"4": 0.007598,
			"5": 0.022794,
			"6": null,
			"7": 0.007598,
			"8": 0.053186,
			"9": 0.045588,
			"10": 0.258332,
			"3.1": null,
			"3.2": null,
			"5.1": 0.030392,
			"6.1": 0.022794,
			"7.1": 0.015196,
			"9.1": 0.220342
		},
		"ios_saf": {
			"8": 0,
			"10": 1.269266,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.03420525,
			"8.1-8.4": 0.06319275,
			"9.0-9.2": 0.030147,
			"9.3": 0.459935
		},
		"android": {
			"3": 0,
			"4": 0.108009312661,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0135011640827,
			"4.1": 0.389605020672,
			"4.2-4.3": 0.97401255168,
			"4.4": 2.23347828682,
			"4.4.3-4.4.4": 2.25276566408
		},
		"ie": {
			"6": 0.0157323294118,
			"7": 0.0235984941176,
			"8": 0.393308235294,
			"9": 0.149457129412,
			"10": 0.102260141176,
			"11": 1.32151567059,
			"5.5": null
		},
		"op_mob": {
			"0": 0.164488735935,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00456913155374
		},
		"edge": {
			"12": 0.068382,
			"13": 0.22794,
			"14": 0.296322
		},
		"ie_mob": {
			"10": 0.128354760563,
			"11": 0.522587239437
		},
		"bb": {
			"7": 0.3681065,
			"10": null
		},
		"samsung": {
			"0": 0.653344
		},
		"and_uc": {
			"0": 0.367506
		},
		"op_mini": {
			"0": 2.21612813251
		},
		"and_chr": {
			"0": 14.371912
		},
		"and_ff": {
			"0": 0.08407
		}
	},
	"total": 97.6137205
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/VE.json
 ** module id = 677
 ** module chunks = 0
 **/